import {
    DELETE_USER_GROUP,
    DELETE_USER_GROUP_ERROR,
    DELETE_USER_GROUP_SUCCESS,
    DeleteUserGroupActionTypes,
    FETCH_USER_GROUP,
    FETCH_USER_GROUP_ERROR,
    FETCH_USER_GROUP_SUCCESS,
    FETCH_USER_GROUPS,
    FETCH_USER_GROUPS_BY_USER,
    FETCH_USER_GROUPS_BY_USER_ERROR,
    FETCH_USER_GROUPS_BY_USER_SUCCESS,
    FETCH_USER_GROUPS_ERROR,
    FETCH_USER_GROUPS_SUCCESS,
    FetchUserGroupActionTypes,
    FetchUserGroupByUserActionTypes,
    SAVE_USER_GROUP_FORM,
    SAVE_USER_GROUP_FORM_ERROR,
    SAVE_USER_GROUP_FORM_SUCCESS,
    SaveUserGroupActionTypes,
    UserGroupActionTypes
} from "../../actions/user-groups/UserGroupsActions";

import {UserGroup} from "../../models/user-groups/UserGroup"
import {RequestState, successFetchingRequestState} from "../../models/common/RequestState";
import {Nullable} from "../../models/common/Nullable";

export interface UserGroupsState {
    totalEntries: number
    userGroups: Nullable<UserGroup[]>,
    detailedUserGroups: Nullable< { [ key: number ]: Nullable< UserGroup > }>
    users: { [ key: number ]: UserGroup[] }
    request: RequestState
}

const initialState: UserGroupsState = {
    totalEntries: 0,
    userGroups: null,
    detailedUserGroups: {},
    users: {},
    request: { error: null, isFetching: false, lastRequestSuccess: 0 }
};

export const UserGroupsReducer = ( state = initialState, action: UserGroupActionTypes | SaveUserGroupActionTypes | DeleteUserGroupActionTypes | FetchUserGroupByUserActionTypes | FetchUserGroupActionTypes ) => {
    switch( action.type ) {
        case FETCH_USER_GROUPS:
            return {
                ...state,
                request: {
                    error: null,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_USER_GROUPS_SUCCESS:

            return {
                ...state,
                totalEntries: action.payload.totalEntries,
                userGroups: action.payload.entries,
                request: {
                    error: null,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case FETCH_USER_GROUPS_ERROR:

            return {
                ...state,
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        case SAVE_USER_GROUP_FORM:
            return {
                ...state,
                request: {
                    error: null,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case SAVE_USER_GROUP_FORM_SUCCESS:
            return {
                ...state,
                request: {
                    ...state.request,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case SAVE_USER_GROUP_FORM_ERROR: 
            return {
                ...state,
                request: {
                    ...state.request,
                    isFetching: false,
                    error: action.error
                }
            };
        case DELETE_USER_GROUP: 
        console.log( action );
            return {
                ...state,
                request: {
                    ...state.request,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case DELETE_USER_GROUP_ERROR: 
            return {
                ...state,
                request: {
                    ...state.request,
                    isFetching: false,
                    error: action.error   
                }
            };
        case DELETE_USER_GROUP_SUCCESS: 
            return {
                ...state
            };

        case FETCH_USER_GROUPS_BY_USER:
            return {
                ...state,
                request: {
                    error: null,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_USER_GROUPS_BY_USER_SUCCESS:
            return {
                ...state,
                users: {
                    ...state.users,
                    [ action.userId ]: action.groups
                },
                request: {
                    error: null,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case FETCH_USER_GROUPS_BY_USER_ERROR:
            return {
                ...state,
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_USER_GROUP:
            return {
                ...state,
                request: {
                    error: null,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_USER_GROUP_SUCCESS:
            return {
                ...state,
                request: successFetchingRequestState(),
                detailedUserGroups: {
                    ...state.detailedUserGroups,
                    [ action.group.userGroupId.rawValue ]: action.group
                }
            };
        case FETCH_USER_GROUP_ERROR:
            return {
                ...state,
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        default:
            return state;
    }
};